// extracted by mini-css-extract-plugin
module.exports = {"boxStyles":"ProductFeatures_boxStyles__Rz5dd"};